import { Component } from "@angular/core";

@Component({
  selector: "app-teams2-content",
  templateUrl: "teams2-content.component.html",
})
export class Teams2ContentComponent {}
